import React, { Fragment } from 'react';

import UseKpiViewHeadCoachReport from './UseKpiViewHeadCoachReport';

import KpiOverrideScoreForm from './KpiOverrideScoreForm';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import HeadCoachReportGrid from '@usas/ui-web/components/grids/kpis/HeadCoachReportGrid';

import Constants from '@usas/ui-web/utils/Constants';

const Question = ({ question }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: question }} />
  );
};

const KpiViewHeadCoachReport = ({ programLevel, categoryMeasure, onRedirect, isReadonly, canOverrideScore = false }) => {
  const {
    isEdit,
    isSaving,
    kpiMeasureState,
    recognitionProgramState,
    submitFormCallback
  } = UseKpiViewHeadCoachReport(programLevel, categoryMeasure, isReadonly, onRedirect);

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{categoryMeasure?.measureName}</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          {categoryMeasure?.question ?
            <Question question={categoryMeasure.question} /> : <Fragment />}
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <HeadCoachReportGrid
            data={kpiMeasureState.arrayData}
            isLoading={kpiMeasureState.isArrayLoading} />
        </div>
      </div>
      {canOverrideScore === true && isEdit === true && isReadonly !== true
        ? (
          <KpiOverrideScoreForm
            programLevel={programLevel}
            categoryMeasure={categoryMeasure}
            onRedirect={onRedirect}
            submitFormCallback={submitFormCallback} />
        ) : (
          <div className="row usas-extra-top-margin usas-extra-bottom-margin">
            <div className="col-xs-12 usas-extra-top-margin">
              <SecondaryButton type="button" onClick={() => onRedirect(false)}>Back</SecondaryButton>
            </div>
          </div>
        )
      }
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={kpiMeasureState.isArrayLoading || recognitionProgramState.isArrayLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default KpiViewHeadCoachReport;